export default __webpack_public_path__ + "static/media/persiangaming.547fc288.png";